import type { LowPriceDay } from '@/shared/api/searchLatest';
import type { LowPriceCalendarProduct } from '../model/types';

export function getMinPricesByCheckInDate(products: readonly LowPriceCalendarProduct[]): Map<string, number> {
  return products.reduce<Map<string, number>>((minPrices, product) => {
    if (product.checkInDate && product.price > 0) {
      const currentMinPrice = minPrices.get(product.checkInDate);

      if (currentMinPrice === undefined || product.price < currentMinPrice) {
        minPrices.set(product.checkInDate, product.price);
      }
    }

    return minPrices;
  }, new Map());
}

export function withProductPrices(
  days: readonly LowPriceDay[],
  products: readonly LowPriceCalendarProduct[],
  selectedDate: string | null,
): LowPriceDay[] {
  if (!selectedDate || !products.length) return [...days];

  const minPrice = getMinPricesByCheckInDate(products).get(selectedDate);

  if (minPrice === undefined) return [...days];

  return days.map((day) => (day.date === selectedDate ? { ...day, price: minPrice } : day));
}
